// src/components/elements/Background.js
import React from 'react';

const STRAPI_BASE_URL = process.env.REACT_APP_STRAPI_BASE_URL;

const Background = ({ BackgroundType, BackgroundColorHexCode, Media, zIndex = 0 }) => {
  // Eine leere Klasse als Startpunkt
  let className = '';

  const style = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: zIndex,
  };

  // Hilfsfunktion, um zu prüfen, ob das Media-Objekt ein Video ist
  const isVideoMedia = (media) => {
    return media?.data?.attributes?.mime?.startsWith('video/');
  };

  // Prüfen, ob der aktuelle Medientyp ein Video ist
  const isVideoBackground = isVideoMedia(Media);

  if (BackgroundType === 'Media' && Media?.data?.attributes?.url) {
    const mediaUrl = `${STRAPI_BASE_URL}${Media.data.attributes.url}`;

    if (isVideoBackground) {
          // Wenn es ein Video ist, rendern wir ein <video>-Element
          return (
            <video
              autoPlay    // Video startet automatisch
              loop        // Video wird in einer Schleife abgespielt
              muted       // SEHR WICHTIG: Videos müssen stummgeschaltet sein für Autoplay
              playsInline // Wichtig für iOS, damit Videos direkt im Element abgespielt werden
              style={{
                ...style, // Übernimmt Positionierung und zIndex
                objectFit: 'cover', // Video füllt den gesamten Bereich aus
                filter: 'brightness(0.7)' // Optional: Video etwas abdunkeln, damit Text besser lesbar ist
              }}
              // Optional: Posterbild anzeigen, bevor das Video lädt
              // poster={Media.data.attributes.formats?.thumbnail?.url ? `http://localhost:1337${Media.data.attributes.formats.thumbnail.url}` : ''}
            >
              <source src={mediaUrl} type={Media.data.attributes.mime} />
              Dein Browser unterstützt das Video-Tag nicht.
            </video>
          );
        }
    else{
    style.backgroundImage = `url(${mediaUrl})`;
    style.backgroundSize = 'cover';
    style.backgroundPosition = 'center';
    style.backgroundRepeat = 'no-repeat';
    }
  } else if (BackgroundType === 'Color' && BackgroundColorHexCode) {
    style.backgroundColor = BackgroundColorHexCode;
    console.log('Background farbe:',zIndex, BackgroundColorHexCode);
  } else if (BackgroundType === 'Transparent') {
    // HIER WIRD DIE KLASSE HINZUGEFÜGT
    className = 'frosted-glass'; // Füge die frosted-glass Klasse hinzu
    // keine zusätzliche Änderung nötig
  } else {
    style.backgroundColor = '#ffffff';
    // Optional: Standardhintergrund als Fallback
    //style.backgroundMedia = 'url("https://picsum.photos/800/400")';
    //style.backgroundSize = 'cover';
    //style.backgroundPosition = 'center';
    //style.backgroundRepeat = 'no-repeat';
    console.warn("Background.js: Keine gültigen Bild-/Farbdaten. Standardbild verwendet.");
  }

  return (
    <div style={style} className={className}>
      {}
    </div>
  );
};

export default Background;
